<template>
  <div>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="required three fields">
        <div class="field">
          <label for="doctor">Doctor</label>
          <select
            class="ui fluid search dropdown"
            id="doctor-search"
            v-model="doctor_id"
            name="clinic"
          >
            <option value="all">All</option>
            <option :value="doctor.id" v-for="doctor in doctorsMeta" :key="doctor.id">
              {{ doctor.user.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label for="purchasedDate">From Date</label>
          <div style="text-align: center" class="ui calendar" :id="'from-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'From Date'"
                     readonly=""
                     name="formDate">
            </div>
          </div>
        </div>
        <div class="field">
          <label for="purchasedDate">To Date</label>
          <div style="text-align: center" class="ui calendar" :id="'to-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'To Date'"
                     readonly=""
                     name="toDate">
            </div>
          </div>
        </div>
      </div>
      <div class="ui blue right floated submit button no-print"
           style="background-color: #092442"
           @click="getVisits()">
        Submit
      </div>
    </div>

    <br>
    <div class="ui divider"></div>
    <br>
    
    <div class="centered-header" style="margin-bottom: 10px">
      <h1> Visits </h1>
    </div>

    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>

    <table class="ui very compact center aligned celled table" v-if="!loading && visits.length">
      <thead>
        <tr> 
          <th width="5%">Visit id</th>
          <th width="5%">Reservation id</th>
          <th width="15%">Doctor</th>
          <th width="15%">Patient</th>
          <th>Time</th>
          <th>Started at</th>
          <th>Finished at</th>
          <th width="15%">Package</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody v-for="visit in visits" :key="visit.time">
          <tr 
            v-for="(visitDetail, index) in visit.visit_details"
            :key="visitDetail.id"
          >
            <td 
              :rowspan="visit.visit_details.length" 
              v-if="index === 0"
            > 
              <a class="id-link" @click="goToReservationVisit(visit.reservationVisit.id)">
                {{ visit.reservationVisit.id }}
              </a> 
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :rowspan="visit.visit_details.length" 
              v-if="index === 0"
            > 
              <a class="id-link" @click="goToReservation(visit.reservation_id)">
                {{ visit.reservation_id }}
              </a>
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :rowspan="visit.visit_details.length" 
              v-if="index === 0"
            > 
              {{ getDoctorName(visit.doctor_id) }}
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :rowspan="visit.visit_details.length" 
              v-if="index === 0" 
            > 
              {{ patientsByReservationId[visit.reservation_id].name }}
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :rowspan="visit.visit_details.length" 
              v-if="index === 0"
            > 
              {{ timeFormat(visit.time) }} 
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :rowspan="visit.visit_details.length" 
              v-if="index === 0"
            > 
              {{ (visit.started_at && timeFormat(visit.started_at)) || '-' }} 
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :rowspan="visit.visit_details.length" 
              v-if="index === 0"
            > 
              {{ (visit.finished_at && timeFormat(visit.finished_at)) || '-'}} 
            </td>
            <td style="border-left: 1px solid rgba(34,36,38,.1)"> 
              {{ packagesById[visitDetail.package_id].name }} 
            </td>
            <td> {{ visitDetail.quantity }} </td>
          </tr>
      </tbody>
    </table>
    <div v-if="!loading && visits.length === 0">
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          There is no visits with current filters
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      from_date: window.moment().startOf('day').toString(),
      to_date: window.moment().endOf('day').toString(),
      doctor_id: 'all',
      visits: [],
      packagesById: {},
      patientsByReservationId: {},
      loading: false
    }
  },
  mounted () {
    this.initGUI()
    this.setFiltersFromRouteQuery()
    this.getVisits()
  },
  methods: {
    formatVisits(responseVisits, meta) {
      const reservationVisitsByVisitId = 
        meta.reservation_visits.reduce((obj, rv) => ({...obj, [rv.visit_id]: rv}), {})
      
      this.packagesById = meta.packages.reduce((obj, p) => ({ ...obj, [p.id]: p }), {})
      
      const patientsById = 
        meta.patients.reduce((obj, patient) => ({...obj, [patient.id]: patient}), {});

      this.patientsByReservationId = meta.reservations.reduce((obj, reservation) => ({ 
        ...obj, 
        [reservation.id]: patientsById[reservation.patient_id] 
      }), {});

      this.visits = responseVisits.map(visit => ({
        ...visit,
        reservationVisit: reservationVisitsByVisitId[visit.id]
      }))
    }, 
    setRouteQueryFromFilters() {
      this.$router.replace({ path: '/visits', query: {
        doctor_id: this.doctor_id,
        from_date: JSON.stringify(this.from_date),
        to_date: JSON.stringify(this.to_date)
      }})
    },
    setFiltersFromRouteQuery() {
      let query = this.$route.query
      this.to_date = query.to_date ? 
        window.moment(JSON.parse(query.to_date)) : window.moment().endOf('day').toString() 
      this.from_date = query.from_date ? 
        window.moment(JSON.parse(query.from_date)) : window.moment().startOf('day').toString()  
      this.doctor_id = query.doctor_id ? query.doctor_id : 'all' 
    },
    getVisits() {
      this.loading = true
      this.setRouteQueryFromFilters()
      this.$http.get(`visits/filter`, {
        params: {
          clinic_id: this.getClinicId(),
          from_date: this.from_date,
          doctor_id: this.doctor_id === 'all' ? undefined : this.doctor_id,
          to_date: this.to_date
        }
      })
      .then(res => {
        this.formatVisits(res.data.visits, res.data.meta);
        this.loading = false
      })
      .catch(error => console.log(error));
    },
    initGUI() {
      this.$nextTick(() => {
        $('#doctor-search').dropdown()

        $('#from-date').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.from_date = date
          }
        })

        $(`#from-date`).calendar(
          'set date',
          this.from_date.toDate()
        )

        $('#to-date').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.to_date = date
          }
        })
        
        $(`#to-date`).calendar(
          'set date',
          this.to_date.toDate()
        )
      })
    },
    goToReservation(reservationId) {
      this.navigateTo(`Show_Reservation`, {
        key: 'params',
        value: { id: reservationId }
      })
    },
    goToReservationVisit(reservationVisitId) {
      this.navigateTo(`Show_Visit`, {
        key: 'params',
        value: { reservationVisitId: reservationVisitId }
      })
    },
    timeFormat (time) {
      return window.moment(time).format('LLLL')
    },
    getDoctorName (doctorId) {
      return this.doctorsMeta.find(doctorId).user.name
    }
  },
}
</script>

<style scoped>
  .id-link {
    cursor: pointer; 
    text-decoration:underline;
  }
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/visits/FilteredVisits.vue